import { Link } from 'react-router-dom';
import '../styles/Footer.css'; // Footer ki CSS

// Import social icons from assets
import instagramIcon from '../assets/insta.png';
import facebookIcon from '../assets/fb.png';
import twitterIcon from '../assets/twit.png';
import youtubeIcon from '../assets/you.png';
import linkedinIcon from '../assets/link.png';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-wrapper">
      {/* Animated Background Glows */}
      <div className="footer-bg-glow footer-bg-glow-1"></div>
      <div className="footer-bg-glow footer-bg-glow-2"></div>

      <div className="footer-container">
        {/* ============================= */}
        {/* MAIN FOOTER */}
        {/* ============================= */}
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="footer-logo-icon">🏆</span>
              <span className="footer-logo-text">Verna<span className="footer-logo-highlight">Events</span></span>
            </Link>
            <p className="footer-brand-description">
              India's premier sports event discovery and registration platform. 
              Connecting athletes, teams, and organizers across the nation.
            </p>
            <div className="footer-social">
              <h4>Follow Us</h4>
              <div className="footer-social-icons">
                <a href="#" className="footer-social-icon" title="Instagram">
                  <img src={instagramIcon} alt="Instagram" />
                </a>
                <a href="#" className="footer-social-icon" title="Facebook">
                  <img src={facebookIcon} alt="Facebook" />
                </a>
                <a href="#" className="footer-social-icon" title="Twitter">
                  <img src={twitterIcon} alt="Twitter" />
                </a>
                <a href="#" className="footer-social-icon" title="YouTube">
                  <img src={youtubeIcon} alt="YouTube" />
                </a>
                <a href="#" className="footer-social-icon" title="LinkedIn">
                  <img src={linkedinIcon} alt="LinkedIn" />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Sports Categories */}
          <div className="footer-links">
            <h4 className="footer-heading">Sports</h4>
            <ul>
              <li><Link to="/events? sport=Cricket">🏏 Cricket</Link></li>
              <li><Link to="/events? sport=Football">⚽ Football</Link></li>
              <li><Link to="/events? sport=Basketball">🏀 Basketball</Link></li>
              <li><Link to="/events? sport=Volleyball">🏐 Volleyball</Link></li>
              <li><Link to="/events? sport=Tennis">🎾 Tennis</Link></li>
              <li><Link to="/events? sport=Badminton">🏸 Badminton</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-heading">Get in Touch</h4>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📍</span>
              <div>
                <strong>Address</strong>
                <p> VernaEvents, Justice Dwarakanath Rd, Gaza Park, Sreepally, Bhowanipore, Kolkata, West Bengal 700020</p>
              </div>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📧</span>
              <div>
                <strong>Email</strong>
                <p>info@vernaevents.com</p>
              </div>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">📱</span>
              <div>
                <strong>Phone</strong>
                <p>+91 8017339796</p>
              </div>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">🕐</span>
              <div>
                <strong>Working Hours</strong>
                <p>Mon - Sat: 9 AM - 6 PM</p>
              </div>
            </div>
          </div>
        </div>

        {/* ============================= */}
        {/* NEWSLETTER SECTION */}
        {/* ============================= */}
        <div className="footer-newsletter">
          <div className="footer-newsletter-content">
            <div className="footer-newsletter-text">
              <span className="footer-newsletter-icon">📬</span>
              <div>
                <h4>Subscribe to Our Newsletter</h4>
                <p>Get the latest updates on upcoming events and tournaments</p>
              </div>
            </div>
            <form className="footer-newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="footer-newsletter-input"
                required
              />
              <button type="submit" className="footer-newsletter-btn">
                Subscribe
                <svg className="footer-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </form>
          </div>
        </div>

        {/* ============================= */}
        {/* BOTTOM BAR */}
        {/* ============================= */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} VernaEvents. All rights reserved. Made with ❤️ for sports enthusiasts
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;